/* Obie's Rave Oasis — snake cursor with a light trail, and Obie the snake on the truss.
   Colours follow the lighting desk preset (window.oroPresets / window.oroDesk from the inline script). */
(function () {
  var html = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dpr = Math.min(2, window.devicePixelRatio || 1);

  function rig() {
    var P = window.oroPresets || {}, d = window.oroDesk || {};
    var p = P[d.preset] || P.oasis || { a: '227, 252, 2', b: '252, 135, 255', c: '53, 230, 255' };
    return [p.c, p.a, p.b].map(function (c) { return c.replace(/\s/g, ''); });
  }
  function store(kind, key, val) {
    try { return val === undefined ? window[kind].getItem(key) : window[kind].setItem(key, val); } catch (e) { return null; }
  }

  /* ================= snake cursor ================= */
  (function snakeCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var idx = Number(store('sessionStorage', 'oro-glow')) || 0;
    function colour() { var c = rig(); return c[idx % c.length]; }

    /* A little snake drawn in a 32-unit box: tongue tip at top-left (the hotspot), head, S-curved body, tail bottom-right.
       Rendered at 1x and 2x so it stays crisp on Retina screens. */
    function bez(t, p0, p1, p2, p3) {
      var u = 1 - t;
      return u * u * u * p0 + 3 * u * u * t * p1 + 3 * u * t * t * p2 + t * t * t * p3;
    }
    var BODY = [[11, 11, 18.5, 9.5, 11.5, 19.5, 19, 20.5], [19, 20.5, 25.5, 21.5, 26.5, 25, 29.5, 29.5]];
    function bodyPoints() {
      var out = [];
      BODY.forEach(function (c, seg) {
        for (var i = 0; i <= 14; i++) {
          var t = i / 14, k = (seg + t) / 2;
          out.push({ x: bez(t, c[0], c[2], c[4], c[6]), y: bez(t, c[1], c[3], c[5], c[7]), r: 2.7 - k * 1.95 });
        }
      });
      return out;
    }
    var PTS = bodyPoints();

    function drawSnake(scale, rgb) {
      var cv = document.createElement('canvas'); cv.width = cv.height = 32 * scale;
      var g = cv.getContext('2d');
      g.scale(scale, scale);
      var i, p;
      /* soft glow */
      g.fillStyle = 'rgba(' + rgb + ',.18)';
      for (i = 0; i < PTS.length; i += 2) { p = PTS[i]; g.beginPath(); g.arc(p.x, p.y, p.r + 2.4, 0, 6.2832); g.fill(); }
      /* outline, so he reads over light photos too */
      g.fillStyle = 'rgba(9,9,10,.9)';
      for (i = 0; i < PTS.length; i++) { p = PTS[i]; g.beginPath(); g.arc(p.x, p.y, p.r + .9, 0, 6.2832); g.fill(); }
      g.save(); g.translate(8.6, 8.6); g.rotate(Math.PI / 4);
      g.beginPath(); g.ellipse(0, 0, 5.3, 4.2, 0, 0, 6.2832); g.fill(); g.restore();
      /* tongue */
      g.strokeStyle = '#ff3b4a'; g.lineWidth = 1.15; g.lineCap = 'round';
      g.beginPath(); g.moveTo(5.4, 5.4); g.lineTo(3, 3); g.lineTo(1.4, 2.9); g.moveTo(3, 3); g.lineTo(2.9, 1.4); g.stroke();
      /* body in the rig colour */
      g.fillStyle = 'rgb(' + rgb + ')';
      for (i = 0; i < PTS.length; i++) { p = PTS[i]; g.beginPath(); g.arc(p.x, p.y, p.r, 0, 6.2832); g.fill(); }
      g.save(); g.translate(8.6, 8.6); g.rotate(Math.PI / 4);
      g.beginPath(); g.ellipse(0, 0, 4.4, 3.3, 0, 0, 6.2832); g.fill(); g.restore();
      /* stripes */
      g.fillStyle = 'rgba(9,9,10,.55)';
      [5, 10, 16, 21, 25].forEach(function (n) { p = PTS[n]; g.beginPath(); g.arc(p.x, p.y, p.r * .55, 0, 6.2832); g.fill(); });
      /* highlight along the back */
      g.strokeStyle = 'rgba(255,255,255,.5)'; g.lineWidth = .8;
      g.beginPath(); g.moveTo(PTS[1].x - .6, PTS[1].y - 1.2);
      for (i = 2; i < 18; i++) g.lineTo(PTS[i].x - .6, PTS[i].y - PTS[i].r * .55);
      g.stroke();
      /* eyes */
      [[9.5, 6.7], [6.7, 9.5]].forEach(function (e) {
        g.fillStyle = '#fff'; g.beginPath(); g.arc(e[0], e[1], 1.35, 0, 6.2832); g.fill();
        g.fillStyle = '#09090a'; g.beginPath(); g.arc(e[0] - .35, e[1] - .35, .65, 0, 6.2832); g.fill();
      });
      return cv.toDataURL('image/png');
    }

    function paintCursor() {
      var rgb = colour(), one = drawSnake(1, rgb), two = drawSnake(2, rgb);
      var sharp = 'image-set(url(' + two + ') 2x, url(' + one + ') 1x) 2 2, auto';
      var plain = 'url(' + one + ') 2 2, auto';
      var ok = false;
      try { ok = CSS.supports('cursor', 'image-set(url("' + one + '") 1x) 2 2, auto'); } catch (e) {}
      if (!ok) try { ok = CSS.supports('cursor', '-webkit-image-set(url("' + one + '") 1x) 2 2, auto') && (sharp = '-webkit-' + sharp); } catch (e) {}
      html.style.setProperty('--oro-cursor', ok ? sharp : plain);
    }
    paintCursor();
    html.classList.add('oro-glow');
    document.addEventListener('oro:desk', paintCursor);

    var cv = null, ctx = null, w = 0, h = 0, pts = [], sparks = [], running = false;
    var LIFE = 420;
    if (!reduce) {
      cv = document.createElement('canvas');
      cv.className = 'oro-trail';
      cv.setAttribute('aria-hidden', 'true');
      document.body.appendChild(cv);
      ctx = cv.getContext('2d');
      var size = function () { w = innerWidth; h = innerHeight; cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
      size(); window.addEventListener('resize', size);
    }

    function draw(t) {
      ctx.clearRect(0, 0, w, h);
      pts = pts.filter(function (p) { return t - p.t < LIFE; });
      var rgb = colour();
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (var pass = 0; pass < 2; pass++) {
        for (var i = 1; i < pts.length; i++) {
          var a = 1 - (t - pts[i].t) / LIFE;
          ctx.strokeStyle = pass ? 'rgba(255,255,255,' + (a * .55).toFixed(3) + ')' : 'rgba(' + rgb + ',' + (a * .5).toFixed(3) + ')';
          ctx.lineWidth = pass ? 1.5 + a * 1.5 : 4 + a * 7;
          ctx.beginPath(); ctx.moveTo(pts[i - 1].x, pts[i - 1].y); ctx.lineTo(pts[i].x, pts[i].y); ctx.stroke();
        }
      }
      for (var j = sparks.length - 1; j >= 0; j--) {
        var s = sparks[j];
        s.x += s.vx; s.y += s.vy; s.vy += .12; s.vx *= .96; s.life -= .035;
        if (s.life <= 0) { sparks.splice(j, 1); continue; }
        ctx.fillStyle = 'rgba(' + s.c + ',' + s.life.toFixed(3) + ')';
        ctx.fillRect(s.x, s.y, 2.2, 2.2);
      }
      if (pts.length || sparks.length) requestAnimationFrame(draw);
      else running = false;
    }
    function kick() { if (cv && !running) { running = true; requestAnimationFrame(draw); } }

    /* colour change: a shake (four or more quick reversals inside 700ms) or one super-fast flick */
    var hist = [], lastCrack = 0;
    function crack(x, y) {
      idx = (idx + 1) % 3;
      store('sessionStorage', 'oro-glow', String(idx));
      paintCursor();
      if (!cv) return;
      var rgb = colour();
      for (var i = 0; i < 18; i++) {
        var a = Math.random() * 6.2832, sp = 1.5 + Math.random() * 3.5;
        sparks.push({ x: x + 14, y: y + 14, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 1, life: 1, c: Math.random() < .3 ? '255,255,255' : rgb });
      }
      kick();
    }

    window.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var t = performance.now();
      if (cv) {
        pts.push({ x: e.clientX + 17, y: e.clientY + 18, t: t });
        if (pts.length > 40) pts.shift();
        kick();
      }
      hist.push({ x: e.clientX, y: e.clientY, t: t });
      hist = hist.filter(function (p) { return t - p.t < 700; });
      if (t - lastCrack > 1000) {
        var recent = hist.filter(function (p) { return t - p.t < 70; });
        if (recent.length > 2) {
          var dist = 0;
          for (var r = 1; r < recent.length; r++) dist += Math.hypot(recent[r].x - recent[r - 1].x, recent[r].y - recent[r - 1].y);
          var span = recent[recent.length - 1].t - recent[0].t;
          if (span > 30 && dist / span > 3.6) { lastCrack = t; hist = []; crack(e.clientX, e.clientY); return; }
        }
      }
      if (t - lastCrack > 1000 && hist.length > 6) {
        var flips = 0, dir = 0, run = 0;
        for (var i = 1; i < hist.length; i++) {
          var dx = hist[i].x - hist[i - 1].x;
          if (!dx) continue;
          var s = dx > 0 ? 1 : -1;
          if (s === dir) run += Math.abs(dx);
          else { if (dir && run > 14) flips++; dir = s; run = Math.abs(dx); }
        }
        if (flips >= 4) { lastCrack = t; hist = []; crack(e.clientX, e.clientY); }
      }
    }, { passive: true });
    document.addEventListener('mouseleave', function () { pts = []; });
  })();

  /* ================= Obie on the truss ================= */
  (function obie() {
    var header = document.querySelector('.oro-header-section');
    var cv = document.createElement('canvas');
    cv.className = 'oro-obie';
    cv.setAttribute('aria-hidden', 'true');
    var hit = document.createElement('button');
    hit.type = 'button';
    hit.className = 'oro-obie-hit';
    hit.tabIndex = -1;
    hit.setAttribute('aria-label', 'Obie the snake. Click for a trick');
    hit.title = 'Obie';
    document.body.appendChild(cv);
    document.body.appendChild(hit);
    var ctx = cv.getContext('2d');

    var W = 0, H = 190, top = 51, small = false, N = 18, SEG = 5.2, Y0 = 9, SPEED = 36;
    function size() {
      W = innerWidth;
      top = header ? Math.round(header.getBoundingClientRect().bottom) : 51;
      small = W < 760;
      N = small ? 16 : 18; SEG = small ? 4.4 : 5.2; SPEED = small ? 26 : 36;
      cv.style.top = top + 'px';
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    size();
    window.addEventListener('resize', size);

    /* where he was on the last page, so he keeps crawling instead of reappearing somewhere new */
    var saved = null;
    try { saved = JSON.parse(store('sessionStorage', 'oro-obie')); } catch (e) {}
    var x = saved && saved.x > 0 ? Math.min(saved.x, W - 40) : W * (.2 + Math.random() * .6);
    var dir = saved && saved.dir ? saved.dir : (Math.random() < .5 ? -1 : 1);
    window.addEventListener('pagehide', function () { store('sessionStorage', 'oro-obie', JSON.stringify({ x: x, dir: dir })); });

    var pts = [], i;
    for (i = 0; i < 24; i++) pts.push({ x: x - dir * i * SEG, y: Y0 });

    var mode = 'slither', modeT = 0, nextDangle = 6 + Math.random() * 10, dangleX = x;
    var phase = 0, tongue = 0, nextTongue = 1.5, trick = null, trickN = 0, fired = false;
    var TRICKS = ['loop', 'hop', 'pyro'];

    function slitherShape(k, amp, lift) {
      return { x: x - dir * k * SEG, y: Y0 + lift + amp * Math.sin(phase - k * .75) * (.35 + .65 * Math.sin(Math.PI * (k + 1) / (N + 1))) };
    }
    /* head dips over the edge at dangleX and hangs; the tail stays lying on the truss behind it */
    function dangleShape(k, t) {
      var j = N - 1 - k, hang = Math.round(N * .62), flat = N - 1 - hang;
      if (j <= flat) return { x: dangleX - dir * (flat - j) * SEG, y: Y0 };
      var down = j - flat, sway = Math.sin(t * 1.7) * 9 * (down / hang);
      return { x: dangleX + sway, y: Y0 + down * SEG * .95 };
    }

    function target(k, t) {
      if (mode === 'dangle') return dangleShape(k, t);
      if (mode === 'trick') {
        var u = Math.min(1, trick.t / trick.d);
        if (trick.type === 'loop') {
          var R = N * SEG / 6.2832, rot = u * 6.2832 * dir;
          var ang = -Math.PI / 2 + rot - dir * k * (6.2832 / N);
          return { x: trick.cx + Math.cos(ang) * R, y: Y0 + R + 6 + Math.sin(ang) * R };
        }
        if (trick.type === 'hop') return slitherShape(k, 5, Math.sin(Math.PI * u) * 26); /* bungee bounce below the truss */
        /* pyro: rear the head down and forward, then breathe fire */
        var p = slitherShape(k, 1.5, 0), rear = Math.sin(Math.PI * Math.min(1, u * 1.4));
        if (k < 6) { p.y += rear * (6 - k) * 4.5; p.x += dir * rear * (6 - k) * 1.5; }
        return p;
      }
      return slitherShape(k, 2.6, 0);
    }

    function startTrick() {
      if (mode === 'trick') return;
      var type = TRICKS[trickN++ % TRICKS.length];
      trick = { type: type, t: 0, d: type === 'loop' ? 1.5 : type === 'hop' ? .9 : 1.3, cx: x - dir * N * SEG * .3 };
      fired = false;
      mode = 'trick';
      tongue = .5;
    }
    hit.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!reduce) return startTrick();
      tongue = 1; paint(0);
      setTimeout(function () { tongue = 0; paint(0); }, 700);
    });

    function paint(t) {
      ctx.clearRect(0, 0, W, H);
      var rim = rig()[0], body = '#141418';
      ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      for (var k = N - 1; k > 0; k--) {
        var wdt = 2 + (N - 1 - k) / (N - 1) * (small ? 5.5 : 7);
        ctx.strokeStyle = body; ctx.lineWidth = wdt;
        ctx.beginPath(); ctx.moveTo(pts[k].x, pts[k].y); ctx.lineTo(pts[k - 1].x, pts[k - 1].y); ctx.stroke();
      }
      /* rim light from the rig: one continuous stroke along his back, so the joints don't bead */
      ctx.strokeStyle = 'rgba(' + rim + ',.55)'; ctx.lineWidth = small ? 1.4 : 1.8;
      ctx.beginPath(); ctx.moveTo(pts[N - 4].x - .5, pts[N - 4].y - 1.4);
      for (k = N - 5; k >= 1; k--) ctx.lineTo(pts[k].x - .5, pts[k].y - (small ? 2 : 2.6));
      ctx.stroke();
      var hx = pts[0].x, hy = pts[0].y, a = Math.atan2(pts[0].y - pts[1].y, pts[0].x - pts[1].x);
      ctx.save(); ctx.translate(hx, hy); ctx.rotate(a);
      var r = small ? .85 : 1;
      if (tongue > 0) {
        ctx.strokeStyle = '#ff3b4a'; ctx.lineWidth = 1.3;
        var tl = 6 + 6 * Math.sin(Math.PI * Math.min(1, tongue));
        ctx.beginPath(); ctx.moveTo(5 * r, 0); ctx.lineTo((5 + tl) * r, 0);
        ctx.lineTo((7 + tl) * r, -2 * r); ctx.moveTo((5 + tl) * r, 0); ctx.lineTo((7 + tl) * r, 2 * r); ctx.stroke();
      }
      ctx.fillStyle = body; ctx.beginPath(); ctx.ellipse(1 * r, 0, 7 * r, 5.2 * r, 0, 0, 6.2832); ctx.fill();
      ctx.strokeStyle = 'rgba(' + rim + ',.7)'; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.ellipse(1 * r, 0, 7 * r, 5.2 * r, 0, Math.PI * 1.05, Math.PI * 1.95); ctx.stroke();
      [-1, 1].forEach(function (s) {
        ctx.fillStyle = '#f7f7f4'; ctx.beginPath(); ctx.arc(3 * r, s * 2.4 * r, 1.7 * r, 0, 6.2832); ctx.fill();
        ctx.fillStyle = '#09090a'; ctx.beginPath(); ctx.arc(3.6 * r, s * 2.4 * r, .85 * r, 0, 6.2832); ctx.fill();
      });
      ctx.restore();

      /* keep the click target on him */
      var minX = 1e9, minY = 1e9, maxX = -1e9, maxY = -1e9;
      for (k = 0; k < N; k++) { minX = Math.min(minX, pts[k].x); maxX = Math.max(maxX, pts[k].x); minY = Math.min(minY, pts[k].y); maxY = Math.max(maxY, pts[k].y); }
      var pad = 10;
      hit.style.width = (maxX - minX + pad * 2) + 'px';
      hit.style.height = (maxY - minY + pad * 2) + 'px';
      hit.style.transform = 'translate(' + (minX - pad) + 'px,' + (top + minY - pad) + 'px)';
    }

    if (reduce) {
      mode = 'dangle';
      for (i = 0; i < N; i++) pts[i] = dangleShape(i, 0);
      paint(0);
      window.addEventListener('resize', function () { paint(0); });
      return;
    }

    var last = 0, hidden = false;
    document.addEventListener('visibilitychange', function () { hidden = document.hidden; });
    function loop(now) {
      requestAnimationFrame(loop);
      if (hidden) { last = now; return; }
      var t = now / 1000, dt = last ? Math.min(.05, (now - last) / 1000) : .016;
      last = now;
      modeT += dt;

      if (mode === 'slither') {
        x += dir * SPEED * dt;
        phase += dt * 7;
        if (dir > 0 && x > W - 24) dir = -1;
        if (dir < 0 && x < 24) dir = 1;
        if (modeT > nextDangle) { mode = 'dangle'; modeT = 0; dangleX = x; tongue = 0; }
      } else if (mode === 'dangle') {
        if (modeT > 4.6) { mode = 'slither'; modeT = 0; nextDangle = 12 + Math.random() * 14; }
      } else if (mode === 'trick') {
        trick.t += dt;
        if (trick.type === 'hop') { x += dir * SPEED * dt * 1.6; phase += dt * 12; }
        if (trick.type === 'pyro' && !fired && trick.t > trick.d * .45) {
          fired = true;
          var hx = pts[0].x + dir * 16, hy = top + pts[0].y + 4;
          if (window.oroBurst) window.oroBurst(hx, hy);
        }
        if (trick.t > trick.d) { mode = 'slither'; modeT = 0; }
      }

      if (tongue > 0) tongue = Math.max(0, tongue - dt * 2.2);
      nextTongue -= dt;
      if (nextTongue <= 0) { tongue = 1; nextTongue = 1.6 + Math.random() * 2.4; }

      var ease = Math.min(1, dt * (mode === 'trick' ? 14 : 8));
      for (var k = 0; k < N; k++) {
        var g = target(k, t);
        pts[k].x += (g.x - pts[k].x) * ease;
        pts[k].y += (g.y - pts[k].y) * ease;
      }
      paint(t);
    }
    requestAnimationFrame(loop);
  })();
})();
